import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-12">
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              吃瓜分类导航
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg">
              按分类浏览你感兴趣的爆料内容，找到最适合你的瓜田
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.slice(0, 9).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col p-6 rounded-2xl bg-background-50 hover:bg-background-50/80 transition-all duration-200 cursor-pointer border border-background-200/50"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-heading font-bold text-foreground-950 text-base">
                      {cat.name}
                    </h3>
                    <span className="text-[11px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                      {cat.count.toLocaleString()}条
                    </span>
                  </div>
                  <p className="text-foreground-500 text-sm leading-relaxed">{cat.description}</p>
                </div>
                <i className="ri-arrow-right-line text-foreground-300 group-hover:text-foreground-600 group-hover:translate-x-1 transition-all text-lg flex-shrink-0 mt-3"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}